import React, { useState } from 'react';
import { Link, useParams, useHistory } from "react-router-dom";
import { Row, Col, Form, Button, Alert } from 'react-bootstrap';
import axios from 'axios';

function ResetPassword() {
    const apiUrl = process.env.REACT_APP_URL;
    const { token } = useParams();
    const history = useHistory();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setMessage(null);

        if (newPassword !== confirmPassword) {
            setError('Las contrasenas no coinciden');
            return;
        }

        if (newPassword.length < 6) {
            setError('La contrasena debe tener al menos 6 caracteres');
            return;
        }

        setLoading(true);
        try {
            const res = await axios.post(`${apiUrl}/users/reset_password`, {
                token,
                new_password: newPassword,
            });
            setMessage(res.data.msg);
            setTimeout(() => history.push('/login'), 3000);
        } catch (err) {
            setError(err.response?.data?.error || 'Error al restablecer contrasena');
        }
        setLoading(false);
    };

    return (
        <div className="auth-main-content auth-bg-image">
            <div className="d-table">
                <div className="d-tablecell">
                    <div className="auth-box">
                        <Row className="align-items-center">
                            <Col md={6}>
                                <div className="form-content">
                                    <h1 className="heading">Nueva Contrasena</h1>

                                    {message && (
                                        <Alert variant="success">
                                            {message}
                                            <br />
                                            <small>Redirigiendo al inicio de sesion...</small>
                                        </Alert>
                                    )}
                                    {error && <Alert variant="danger">{error}</Alert>}

                                    {!message && (
                                        <Form onSubmit={handleSubmit}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nueva Contrasena</Form.Label>
                                                <Form.Control
                                                    type="password"
                                                    value={newPassword}
                                                    onChange={(e) => setNewPassword(e.target.value)}
                                                    required
                                                    minLength={6}
                                                    disabled={loading}
                                                />
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label>Confirmar Contrasena</Form.Label>
                                                <Form.Control
                                                    type="password"
                                                    value={confirmPassword}
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                    required
                                                    minLength={6}
                                                    disabled={loading}
                                                />
                                            </Form.Group>

                                            <div className="text-center mb-3">
                                                <Button variant="primary" type="submit" disabled={loading}>
                                                    {loading ? 'Guardando...' : 'Restablecer Contrasena'}
                                                </Button>
                                            </div>
                                        </Form>
                                    )}

                                    <div className="text-center">
                                        <Link to="/login" className="text-primary">
                                            Regresar al inicio de sesion
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ResetPassword;
